
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Punetoshirdiforceurbania() {



    const cardData =
    {
        keyword: ' Pune to Shirdi Force Urbania on Rent',
        heading: 'Samarth Travels: Pune to Shirdi Force Urbania on Rent',
        headingDescription: 'Samarth Travels offers Pune to Shirdi Force Urbania on rent, ideal for comfortable and convenient temple visits with family or groups. Enjoy a smooth ride in our luxury Urbania vans equipped with AC, push-back seats, and spacious interiors. With experienced drivers, transparent pricing, and punctual service, Samarth Travels ensures a peaceful and hassle-free journey to Shirdi.',

        top: 'Top Places to Visit in Pune with Samarth Travels',

        "topPlaces": [
    {
      "title": "Shri Sai Baba Samadhi Mandir",
      "description": "The Shri Sai Baba Samadhi Mandir is the most revered site in Shirdi, housing the final resting place of Sai Baba. Constructed with white marble, the temple features a life-size statue of Sai Baba seated on a throne. Devotees from all over the world visit to pay their respects and seek blessings. The temple complex also includes a museum displaying Sai Baba's personal belongings."
    },
    {
      "title": "Dwarkamai",
      "description": "Dwarkamai is a mosque where Sai Baba spent a significant portion of his life. It is here that he performed miracles and helped people irrespective of their religion. The mosque houses a sacred fire (Dhuni) lit by Sai Baba, which continues to burn to this day, and the sacred stone on which he sat."
    },
    {
      "title": "Chavadi",
      "description": "Chavadi is the place where Sai Baba used to rest every alternate night during the last decade of his life. The building has been preserved as a shrine, and it houses a portrait of Sai Baba and a wooden bed that he used. Every Thursday, a ceremonial procession carries Sai Baba's idol from the Samadhi Mandir to Chavadi."
    },
    {
      "title": "Gurusthan",
      "description": "Gurusthan, meaning 'place of the guru,' is where Sai Baba was first spotted as a young boy under a neem tree. A small shrine with a marble statue of Sai Baba and a shivling marks the spot. Devotees believe that lighting incense sticks here can cure ailments."
    },
    {
      "title": "Dixit Wada Museum",
      "description": "Located within the temple complex, the Dixit Wada Museum showcases a collection of black and white photographs of Sai Baba, his personal items like the robe, pipe, and cooking utensils. The museum offers a glimpse into the simple life of Sai Baba and his teachings."
    },
    {
      "title": "Lendi Baug",
      "description": "Lendi Baug is a garden where Sai Baba used to spend time watering plants and meditating. The garden houses a lamp lit by Sai Baba, which is kept burning inside a small shrine. It's a serene place for devotees to reflect and find peace."
    },
    {
      "title": "Sai Teerth Theme Park",
      "description": "Sai Teerth is India's first devotional theme park, offering an immersive experience into the life and teachings of Sai Baba. The park features 5D shows, animatronic displays, and replicas of famous Indian temples, providing both entertainment and spiritual education."
    },
    {
      "title": "Sai Heritage Village",
      "description": "Sai Heritage Village is a theme park that recreates scenes from Sai Baba's life using statues and exhibits. It provides visitors with a visual representation of the era in which Sai Baba lived, including depictions of his interactions with devotees and daily activities."
    },
    {
      "title": "Wet N Joy Water Park",
      "description": "Wet N Joy is a family-friendly water park located near the Sai Baba temple. It offers a variety of water rides and attractions, making it a popular spot for relaxation and fun, especially during the hot summer months."
    },
    {
      "title": "Shani Shingnapur",
      "description": "Located about 70 kilometers from Shirdi, Shani Shingnapur is a village famous for its temple dedicated to Lord Shani. The village is unique for its houses without doors, reflecting the residents' strong belief in Lord Shani's protection against theft and crime."
    }
  ],

"services": [
    {
        "name": "Rent Force Urbania Bus Pune to Shirdi",
        "description": "Travel from Pune to Shirdi in comfort with Samarth Travels' Force Urbania bus rental. Designed for smooth and safe long-distance travel, our Urbania buses are ideal for pilgrimages, family tours, and group outings."
    },
    {
        "name": "Pune to Shirdi Luxury Urbania Bus Hire",
        "description": "Upgrade your pilgrimage experience with our luxury Force Urbania bus hire service from Pune to Shirdi. Featuring plush seating, air conditioning, and spacious interiors, it’s perfect for comfortable travel with large or VIP groups."
    },
    {
        "name": "Affordable Urbania Bus Rental Pune to Shirdi",
        "description": "Looking for a cost-effective travel option from Pune to Shirdi? Samarth Travels offers affordable Urbania bus rentals without compromising comfort or safety. Ideal for group tours and budget pilgrimages."
    },
    {
        "name": "Rent Urbania Bus for Shirdi Tour from Pune",
        "description": "Plan your next Shirdi trip with ease by renting an Urbania bus from Samarth Travels. Our well-maintained vehicles are perfect for religious tours, complete with driver and fuel-inclusive packages available."
    },
    {
        "name": "Pune to Shirdi Urbania Bus Hire for Group Travel",
        "description": "Whether it's a spiritual group or extended family, our Urbania bus hire service from Pune to Shirdi offers ample seating and top-tier amenities for a smooth and unified travel experience."
    },
    {
        "name": "Urbania Bus Rental Pune to Shirdi for Pilgrimages",
        "description": "For Sai Baba devotees traveling to Shirdi, Samarth Travels provides reliable and comfortable Urbania bus rental services from Pune. Our professional drivers ensure timely arrival and safe transit for your sacred journey."
    },
    {
        "name": "Comfortable Urbania Bus for Pune to Shirdi Trip",
        "description": "Experience unmatched comfort during your Pune to Shirdi trip with our Force Urbania rental. Designed for long drives, the vehicle includes reclining seats, strong AC, and plenty of luggage space."
    },
    {
        "name": "Luxury Urbania Bus Hire for Pune to Shirdi Trip",
        "description": "Choose luxury for your religious journey from Pune to Shirdi. Our premium Urbania buses are ideal for groups seeking extra comfort, elegant interiors, and a smooth ride across the highway."
    },
    {
        "name": "32-Seater Urbania Bus on Rent Pune to Shirdi",
        "description": "Need extra space for a large group? Book our 32-seater Urbania bus for your Pune to Shirdi tour. With modern amenities and a seasoned driver, it's the perfect fit for extended families, corporate groups, or temple associations."
    },
    {
        "name": "Rent Urbania Bus for Family Tour to Shirdi",
        "description": "Make your family pilgrimage to Shirdi memorable with Samarth Travels’ Urbania bus rental. Our vehicles are family-friendly, with clean interiors, flexible pickup times, and seamless travel arrangements."
    }
],
"tableData": [
    ["Rent Force Urbania Bus Pune to Shirdi", "Pune to Shirdi Luxury Urbania Bus Hire"],
    ["Affordable Urbania Bus Rental Pune to Shirdi", "Rent Urbania Bus for Shirdi Tour from Pune"],
    ["Pune to Shirdi Urbania Bus Hire for Group Travel", "Urbania Bus Rental Pune to Shirdi for Pilgrimages"],
    ["Comfortable Urbania Bus for Pune to Shirdi Trip", "Luxury Urbania Bus Hire for Pune to Shirdi Trip"],
    ["32-Seater Urbania Bus on Rent Pune to Shirdi", "Rent Urbania Bus for Family Tour to Shirdi"]
],


    

"whychoose": [
    {
        "WhyChooseheading": "Luxury Force Urbania on Rent from Pune to Shirdi",
        "WhyChoosedescription": "Travel in style and comfort with Samarth Travels’ Force Urbania rental service from Pune to Shirdi. Whether you're visiting Sai Baba Temple with family, a group of devotees, or on a private religious tour, our premium Urbania ensures a relaxed and divine journey to this sacred destination."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Ride for Pilgrimage Travel",
        "WhyChoosedescription": "Our Urbania offers spacious seating, superior air-conditioning, individual reading lights, and a smooth suspension system—perfect for long-distance rides. With pushback seats and ample legroom, every passenger can enjoy a fatigue-free, comfortable journey to Shirdi."
    },
    {
        "WhyChooseheading": "Experienced Chauffeurs Who Know the Route Well",
        "WhyChoosedescription": "Our professional chauffeurs are courteous, punctual, and well-versed with the Pune to Shirdi route. From managing highway tolls to navigating temple drop-off zones, they ensure a peaceful, timely, and safe journey, allowing you to focus on your spiritual experience."
    },
    {
        "WhyChooseheading": "Ideal for Family Trips, Devotee Groups, or VIP Travel",
        "WhyChoosedescription": "The Force Urbania is perfect for mid-sized groups, families, or VIPs traveling to Shirdi. Its luxurious interiors and private setting make it a great choice for anyone looking for a comfortable yet exclusive pilgrimage trip."
    },
    {
        "WhyChooseheading": "All-Inclusive and Transparent Rental Pricing",
        "WhyChoosedescription": "With Samarth Travels, there are no hidden charges. Our Pune to Shirdi Urbania rental packages include driver charges, tolls, and fuel. We offer competitive pricing with clear terms, so you can travel with confidence and budget certainty."
    },
    {
        "WhyChooseheading": "24/7 Availability and Flexible Pickup Times",
        "WhyChoosedescription": "We operate around your schedule. Whether you prefer a late-night departure or an early morning trip, our Force Urbania is available 24/7. Enjoy door-to-door pickup from your home, hotel, or office in Pune for maximum convenience."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Maintained to Perfection",
        "WhyChoosedescription": "Your safety and hygiene are our priorities. Every Urbania vehicle is deep cleaned and sanitized before each trip. Our fleet undergoes regular mechanical checks to ensure a smooth, safe, and dependable ride on longer routes like Pune to Shirdi."
    },
    {
        "WhyChooseheading": "Flexible Payment Options and Easy Booking",
        "WhyChoosedescription": "Booking your Pune to Shirdi Urbania is simple with Samarth Travels. We accept UPI, credit/debit cards, digital wallets, and cash. Whether you’re booking online or over the phone, our process is fast, secure, and customer-friendly."
    }
]























    }

const faqData = [
    {
        id: 1,
        question: 'How do I book a Force Urbania from Pune to Shirdi with Samarth Travels?',
        answer: 'Booking a Force Urbania from Pune to Shirdi is simple with Samarth Travels. You can book online or contact our customer support team directly. Provide your travel date, group size, and pickup location, and we will schedule a luxury Urbania for your trip.',
    },
    {
        id: 2,
        question: 'What amenities are available in the Force Urbania for Pune to Shirdi travel?',
        answer: 'Our Force Urbania is a premium vehicle equipped with pushback seats, air conditioning, USB charging ports, large windows, reading lights, and ample luggage space. It ensures a comfortable and relaxing ride to Shirdi.',
    },
    {
        id: 3,
        question: 'Is the Urbania ideal for long-distance religious trips like Pune to Shirdi?',
        answer: 'Yes, the Force Urbania is ideal for religious journeys. It’s designed for long-distance comfort, with smooth suspension, spacious interiors, and reliable performance — perfect for a peaceful trip to Shirdi.',
    },
    {
        id: 4,
        question: 'How many passengers can the Force Urbania accommodate?',
        answer: 'Our Force Urbania comes in 10 to 17-seater variants, making it suitable for families, spiritual tour groups, or small corporate outings.',
    },
    {
        id: 5,
        question: 'What is included in the rental for Pune to Shirdi Urbania service?',
        answer: 'The rental includes the luxury Urbania vehicle, driver, and fuel costs. Any tolls, parking charges, or applicable permits will be shared transparently during booking for a hassle-free experience.',
    },
    {
        id: 6,
        question: 'Are multiple pickup and drop locations available in Pune?',
        answer: 'Yes, we offer flexible pickup and drop-off options across Pune. You can customize your itinerary according to your group’s convenience.',
    },
    {
        id: 7,
        question: 'Do you provide one-way and round-trip options for Shirdi?',
        answer: 'Yes, we provide both one-way and round-trip bookings from Pune to Shirdi. Round-trip rentals are ideal if you plan to return on the same or next day and offer better value for money.',
    },
];

const testimonials = [
    {
        name: 'Mr. Suresh Gawande',
        role: 'Family Group Leader',
        text: 'We booked the Urbania for our Pune to Shirdi trip with 12 family members. The vehicle was spotless, luxurious, and extremely comfortable. Our driver was punctual and respectful. Great service by Samarth Travels!',
        image: '/img/testimonial/testi_2_58.jpg',
    },
    {
        name: 'Mrs. Meenal Desai',
        role: 'Tour Organizer',
        text: 'The Force Urbania was perfect for our spiritual journey to Shirdi. Quiet, smooth ride and clean interiors made the trip relaxing. Samarth Travels handled everything professionally. Will definitely recommend!',
        image: '/img/testimonial/testi_2_59.jpg',
    },
];





























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Force Urbania on Rent",
  "image": "https://samarthtravels.com/assets/images/pune-to-shirdi-urbania-bus.jpg",
  "description": "Rent a Luxury Force Urbania Bus for Pune to Shirdi trips. Affordable rental options for 32-seater Urbania buses, perfect for group travel, pilgrimages, family tours, and luxury travel.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/pune-to-shirdi-force-urbania-on-rent"
  }
};





    return (
        <div>


<Helmet>
  <title>Pune to Shirdi Force Urbania on Rent | Luxury & Affordable Options | Samarth Travels</title>
  <meta 
    name="description" 
    content="Rent a Luxury Force Urbania Bus for Pune to Shirdi trips. Affordable rental options for 32-seater Urbania buses, perfect for group travel, pilgrimages, family tours, and luxury travel." 
  />
  <meta 
    name="keywords" 
    content="Rent Force Urbania Bus Pune to Shirdi, Pune to Shirdi Luxury Urbania Bus Hire, Affordable Urbania Bus Rental Pune to Shirdi, Rent Urbania Bus for Shirdi Tour from Pune, Pune to Shirdi Urbania Bus Hire for Group Travel, Urbania Bus Rental Pune to Shirdi for Pilgrimages, Comfortable Urbania Bus for Pune to Shirdi Trip, Luxury Urbania Bus Hire for Pune to Shirdi Trip, 32-Seater Urbania Bus on Rent Pune to Shirdi, Rent Urbania Bus for Family Tour to Shirdi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/36.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoshirdiforceurbania;